export default __webpack_public_path__ + "static/media/cgv_combo_mr_2020.a0d4cc08.jpg";